
import { apiURLs as Organization } from '../../shared/services/register.service';
import { apiURLs as Translations } from '../../shared/services/custom-translate-loader.service';
import { apiURLs as Contact } from "../../pages/contact/contact.service";

// set header name that contains versions of data
export const headerName = 'Version';
// set keys as data names in req header
export const versionsURLs = {
};